export default "__VITE_ASSET__CVZDyrDy__"